import React from "react";
import useI18nInit from "../hooks/useI18nInit";
import I18n from "../libs/i18n/I18n";
function I18nProvider(props) {
    const i18nValue = useI18nInit(props.language, props.pathMap);
    return (React.createElement(I18n.Provider, { value: i18nValue },
        i18nValue.state.status === "pending" && props.pending,
        i18nValue.state.status === "error" && props.error,
        i18nValue.state.status === "ok" && props.children));
}
export default I18nProvider;
